module.exports = __webpack_public_path__ + "static/media/25UNHCR3.aeb8f989.jpg";